import "./index.scss";
import report from "@report";
import { NationalFlag } from "@components/NationalFlag";
import { Form, Select } from "antd";
import classNames from "classnames";
import { IconArrowDown } from "@icons/index";

const { Option } = Select;
const PrefixSelector = (props: { userTelephone: any[]; onChange: Function; className?: string }) => {
  return (
    <div
      onClick={(e) => {
        if (!(e.target as HTMLElement)?.closest(".ant-select-item")) {
          report.click({
            kalo_pos: "phone-prefix",
          });
        } else {
        }
      }}
    >
      <Form.Item name="prefix" noStyle>
        <Select
          className={classNames(props.className)}
          onChange={(val) => {
            props.onChange(val);
            report.click({
              kalo_pos: "choose-phone-prefix",
              kalo_value: val,
            });
          }}
          suffixIcon={<IconArrowDown className="w-[18px] h-[18px]" />}
          virtual={false}
          listHeight={300}
          popupMatchSelectWidth={false}
        >
          {props.userTelephone.map((el: any) => {
            return (
              <Option value={el.code} key={el.code}>
                <div className="select-wrapper">
                  <NationalFlag url={el.icon}></NationalFlag>
                  <span className="">
                    {el.value}
                    {" +"}
                    {el.code}
                  </span>
                </div>
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    </div>
  );
};

export default PrefixSelector;
